import { request } from "../helpers/axios.new";

// Dedupe concurrent / repeat GETs for the same review (Timeline can mount
// several integrated-ref rows that share a review, or remount briefly while
// catalogs load). Cache is process-lifetime; reviews rarely change mid-session.
const reviewCache = new Map();
const reviewInflight = new Map();

export const FETCH_REVIEW = (reviewId) => {
  const id = String(reviewId || "");
  if (!id) return Promise.reject(new Error("Empty review id"));

  if (reviewCache.has(id)) {
    return Promise.resolve({ data: reviewCache.get(id) });
  }

  if (reviewInflight.has(id)) {
    return reviewInflight.get(id);
  }

  const pending = request({ url: `/reviews/review/${id}` })
    .then((response) => {
      reviewCache.set(id, response.data);
      reviewInflight.delete(id);
      return response;
    })
    .catch((error) => {
      reviewInflight.delete(id);
      throw error;
    });

  reviewInflight.set(id, pending);
  return pending;
};
